import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import DisplayCommentLines from "csi/middleware/customView/options/DisplayCommentLines";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import DataSheetTableOptionsStore from "./DataSheetTableOptionsStore";
import { isDefined } from "csi/utility/coreUtility";

const DataSheetTableViewOptions: FunctionComponent = observer(function DataSheetTableViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options,
		setDisplayCommentLines, 
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as DataSheetTableOptionsStore;

	const {
		displayCommentLines,
	} = options;

	return (
		<>
			{isDefined(displayCommentLines) && (
				<CustomViewOptionCustomSection
					collapsed={viewSpecificOptionsCollapse}
					dataCsiAutomation="CustomViewDataSheetOptions"
					onCollapse={toggleCollapsedViewSpecificOptions}
					titleRes="CustomViewDataSheetOptions"
				>
					<DisplayCommentLines
						onChange={setDisplayCommentLines}
						value={displayCommentLines}
					/>
				</CustomViewOptionCustomSection>
			)}
		</>
	);
});

export default DataSheetTableViewOptions;